<ng-container *transloco="let translate">
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <h1 class="text-xl font-semibold" [textContent]="translate('Audit Trails')"></h1>
        <material-button class="p-2 rounded-full" [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" [classList]="['focus:!outline-none', 'hover:!bg-gray-100']" (buttonClicked)="closeModal()"></material-button>
    </div>
    <mat-dialog-content class="w-full h-[80%] overflow-auto px-4 py-2 relative !left-[15px]">
        <ng-container *ngIf="changeLogs?.length > 0; else noChangeLog">
            <mat-accordion>
                <div *ngFor="let log of changeLogs; trackBy: trackByFn" class="auditChangeLogContainer">
                    <ng-container *ngFor="let userLog of log.users; let i = index">
                        <app-commonchangelogrecord [log]="userLog" [entity]="data?.entity" [index]="i"></app-commonchangelogrecord>
                    </ng-container>
                </div>
            </mat-accordion>
        </ng-container>
        <ng-template #noChangeLog>
            <div class="h-full noChangeLogDiv d-flex justify-content-center align-items-center">
                <span [textContent]="translate('No Logs Found.')"></span>
            </div>
        </ng-template>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]">
        <material-button [text]="translate('Close')" (buttonClicked)="closeModal()"></material-button>
    </mat-dialog-actions>
</ng-container>
